type Color = {
    fill: string;
    stroke: string;
};
type Constants = {
    colors: {
        pallet: {
            secondary: string;
            green: string;
            blue: string;
            red: string;
            black: string;
            purple: string;
            purpleBackground: string;
            lightGreen: string;
            lightBlack: string;
            white: string;
            error: string;
            disabled: string;
            vakePurple: string;
            chilledBlue: string;
        };
        markers: {
            undetectedAis: Color;
            matchedVessels: Color;
            pink: Color;
            darkShips: Color;
            staticObjects: Color;
            yellow: Color;
            acquisitions: Color;
        };
    };
    breakpoints: {
        mobile: string;
        miniTablet: string;
        navigation: string;
    };
    sizes: {
        container: string;
    };
};

const constants: Constants = {
    colors: {
        pallet: {
            secondary: '#737373',
            green: '#00FF47',
            blue: '#00A1FF',
            red: '#EB3223',
            purple: '#8136F6',
            purpleBackground: '#9A67FF',
            lightGreen: '#64FBB8',
            error: '#FF0055',
            disabled: '#D1D1D1',
            black: '#000',
            lightBlack: '#2C2E33',
            white: '#FFFFFF',
            vakePurple: '#3324E9',
            chilledBlue: '#3391cc',
        },
        markers: {
            undetectedAis: { fill: '#00A0FF', stroke: '#006099' },
            darkShips: { fill: '#FF5100', stroke: '#993100' },
            pink: { fill: '#FF65FF', stroke: '#993D99' },
            matchedVessels: { fill: '#14FF00', stroke: '#0C9900' },
            staticObjects: { fill: '#000', stroke: '#00A1FF' },
            yellow: { fill: '#FED709', stroke: '#FED709' },
            acquisitions: { fill: '#888', stroke: '#999' },
        },
    },
    breakpoints: {
        mobile: '600px',
        miniTablet: '1000px',
        navigation: '950px',
    },
    sizes: {
        container: '1255px',
    },
};

export const DEFAULT_ZOOM_LEVEL = 5;
export const INSIGHT_ZOOM_LEVEL = 9.5;
export const FLY_TO_DURATION = 3000; // 3 seconds
export const WEB_MAP_TILE_SERVICE_MIN_ZOOM = 8.5;

export const elevatedTags = ['Transshipment', 'Sanctioned', 'Problematic Flag'];
export const otherTags = [
    'No Tag',
    'Awaiting Tag',
    'Image Edge',
    'Partly Cloudy',
    'Mostly Cloudy',
    'Overcast',
    'Valid MMSI',
    'Invalid MMSI',
];
export const allTags = [...elevatedTags, ...otherTags];
export const allTagsActor = [...allTags, 'AIS gap > 48h', 'Flag Change'];
export const millisecondsInOneDay = 1000 * 60 * 60 * 24;
export default constants;
